import {
  CoverPageOfferFragment as CoverPageOffer,
  OfferAccessState,
  OfferKind,
  OfferScope
} from "@pathwright/graphql-client/src/generated"

/** Licensor school id for sandbox offers (must match CoverPageOfferFragment). */
const SANDBOX_LICENSOR_SCHOOL_ID = 999_999

export const offerPermutations: { label: string; offer: CoverPageOffer }[] = [
  // Free (no price label)
  {
    label: "Free (no price label)",
    offer: {
      id: 1,
      school_id: SANDBOX_LICENSOR_SCHOOL_ID,
      cover_page_id: 1,
      kind: OfferKind.JoinCohort,
      cohort_id: 1,
      resource_license_offering_id: null,
      scope: OfferScope.Member,
      title: "Free Cohort",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      cta_label: null,
      external_url: null,
      position: null,
      price_options: [
        {
          option_label: "",
          button_label: "Join for free",
          price_description: ""
        }
      ],
      access: {
        meta: [],
        state: OfferAccessState.Available
      }
    }
  },
  // Free (with price label)
  {
    label: "Free (with price label)",
    offer: {
      id: 2,
      school_id: SANDBOX_LICENSOR_SCHOOL_ID,
      cover_page_id: 1,
      kind: OfferKind.JoinCohort,
      cohort_id: 2,
      resource_license_offering_id: null,
      scope: OfferScope.Member,
      title: "Free Cohort (Labeled)",
      description:
        "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit.",
      cta_label: null,
      external_url: null,
      position: null,
      price_options: [
        {
          option_label: "",
          button_label: "Join for free",
          price_description: ""
        }
      ],
      access: {
        meta: [],
        state: OfferAccessState.Available
      }
    }
  },
  // One-off paid
  {
    label: "One-off paid",
    offer: {
      id: 3,
      school_id: SANDBOX_LICENSOR_SCHOOL_ID,
      cover_page_id: 1,
      kind: OfferKind.JoinCohort,
      cohort_id: 3,
      resource_license_offering_id: null,
      scope: OfferScope.Member,
      title: "Paid Cohort",
      description:
        "Voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit.",
      cta_label: null,
      external_url: null,
      position: null,
      price_options: [
        {
          option_label: "",
          button_label: "Join for $199",
          price_description: ""
        }
      ],
      access: {
        meta: [],
        state: OfferAccessState.Available
      }
    }
  },
  // Subscription (monthly)
  {
    label: "Subscription (monthly)",
    offer: {
      id: 4,
      school_id: SANDBOX_LICENSOR_SCHOOL_ID,
      cover_page_id: 1,
      kind: OfferKind.JoinCohort,
      cohort_id: 4,
      resource_license_offering_id: null,
      scope: OfferScope.Member,
      title: "Monthly Subscription",
      description:
        "Anim id est laborum et dolorum fuga. Et harum quidem rerum facilis est et expedita distinctio. Nam libero tempore, cum soluta nobis est eligendi optio.",
      cta_label: null,
      external_url: null,
      position: null,
      price_options: [
        {
          option_label: "",
          button_label: "Subscribe",
          price_description: "<strong>$19</strong>/mo."
        }
      ],
      access: {
        meta: [],
        state: OfferAccessState.Available
      }
    }
  },
  // Subscription (annual)
  {
    label: "Subscription (annual)",
    offer: {
      id: 5,
      school_id: SANDBOX_LICENSOR_SCHOOL_ID,
      cover_page_id: 1,
      kind: OfferKind.JoinCohort,
      cohort_id: 5,
      resource_license_offering_id: null,
      scope: OfferScope.Member,
      title: "Annual Subscription",
      description:
        "Cumque nihil impedit quo minus id quod maxime placeat facere possimus, omnis voluptas assumenda est, omnis dolor repellendus. Temporibus autem quibusdam.",
      cta_label: null,
      external_url: null,
      position: null,
      price_options: [
        {
          option_label: "",
          button_label: "Subscribe",
          price_description: "<strong>$19</strong>/mo. paid annually"
        }
      ],
      access: {
        meta: [],
        state: OfferAccessState.Available
      }
    }
  },
  // Both one-off and subscription (radio)
  {
    label: "One-off or Subscription (radio)",
    offer: {
      id: 6,
      school_id: SANDBOX_LICENSOR_SCHOOL_ID,
      cover_page_id: 1,
      kind: OfferKind.JoinCohort,
      cohort_id: 6,
      resource_license_offering_id: null,
      scope: OfferScope.Member,
      title: "Flexible Cohort",
      description:
        "Et autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur.",
      cta_label: null,
      external_url: null,
      position: null,
      price_options: [
        {
          option_label: "$199",
          button_label: "Join for $199",
          price_description: ""
        },
        {
          option_label: "Subscribe",
          button_label: "Subscribe",
          price_description: "Starts at <strong>$19</strong>/mo."
        }
      ],
      access: {
        meta: [],
        state: OfferAccessState.Available
      }
    }
  },
  // Already joined (in progress)
  {
    label: "Already joined (in progress)",
    offer: {
      id: 7,
      school_id: SANDBOX_LICENSOR_SCHOOL_ID,
      cover_page_id: 1,
      kind: OfferKind.JoinCohort,
      cohort_id: 7,
      resource_license_offering_id: null,
      scope: OfferScope.Member,
      title: "Joined Cohort",
      description:
        "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi.",
      cta_label: null,
      external_url: null,
      position: null,
      price_options: [
        {
          option_label: "",
          button_label: "Continue",
          price_description: ""
        }
      ],
      access: {
        meta: [],
        state: OfferAccessState.Active
      }
    }
  },
  // Already joined (completed) - I don't think completed Cohorts appear
  // {
  //   label: "Already joined (completed)",
  //   offer: {
  //     id: 8,
  //     title: "Completed Cohort",
  //     description: "Sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis.",
  //     order: 0,
  //     price_options: [
  //       {
  //         option_label: "",
  //         button_label: "Continue",
  //         price_label: "Already enrolled",
  //         price_description: ""
  //       }
  //     ],
  //     access: {
  //       meta: [],
  //       state: "active"
  //     }
  //   }
  // },
  // Subscription included
  {
    label: "Included in Subscription",
    offer: {
      id: 9,
      school_id: SANDBOX_LICENSOR_SCHOOL_ID,
      cover_page_id: 1,
      kind: OfferKind.JoinCohort,
      cohort_id: 9,
      resource_license_offering_id: null,
      scope: OfferScope.Member,
      title: "Subscription Included",
      description:
        "Est et expedita distinctio. Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus id quod maxime placeat facere possimus.",
      cta_label: null,
      external_url: null,
      position: null,
      price_options: [
        {
          option_label: "",
          button_label: "Join",
          price_description: "Included in your subscription"
        }
      ],
      access: {
        meta: [],
        state: OfferAccessState.Available
      }
    }
  },
  // Registration closed
  {
    label: "Registration closed",
    offer: {
      id: 10,
      school_id: SANDBOX_LICENSOR_SCHOOL_ID,
      cover_page_id: 1,
      kind: OfferKind.JoinCohort,
      cohort_id: 10,
      resource_license_offering_id: null,
      scope: OfferScope.Member,
      title: "Closed Cohort",
      description:
        "Omnis voluptas assumenda est, omnis dolor repellendus. Temporibus autem quibusdam et aut officiis debitis aut rerum necessitatibus saepe eveniet ut et voluptates repudiandae.",
      cta_label: null,
      external_url: null,
      position: null,
      price_options: [
        {
          option_label: "",
          button_label: "Join for free",
          price_description: ""
        }
      ],
      access: {
        meta: ["Registration ended on May 1, 2025"],
        state: OfferAccessState.Unavailable
      }
    }
  },
  // No seats available
  {
    label: "No seats available",
    offer: {
      id: 11,
      school_id: SANDBOX_LICENSOR_SCHOOL_ID,
      cover_page_id: 1,
      kind: OfferKind.JoinCohort,
      cohort_id: 11,
      resource_license_offering_id: null,
      scope: OfferScope.Member,
      title: "Full Cohort",
      description:
        "Sint et molestiae non recusandae. Itaque earum rerum hic tenetur a sapiente delectus, ut aut reiciendis voluptatibus maiores alias consequatur aut perferendis.",
      cta_label: null,
      external_url: null,
      position: null,
      price_options: [
        {
          option_label: "",
          button_label: "Join for free",
          price_description: ""
        }
      ],
      access: {
        meta: ["No seats remaining"],
        state: OfferAccessState.Unavailable
      }
    }
  },
  // Limited seats
  {
    label: "Limited seats",
    offer: {
      id: 12,
      school_id: SANDBOX_LICENSOR_SCHOOL_ID,
      cover_page_id: 1,
      kind: OfferKind.JoinCohort,
      cohort_id: 12,
      resource_license_offering_id: null,
      scope: OfferScope.Member,
      title: "Limited Cohort",
      description:
        "Doloribus asperiores repellat. Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae.",
      cta_label: null,
      external_url: null,
      position: null,
      price_options: [
        {
          option_label: "",
          button_label: "Join",
          price_description: "Included in your subscription"
        }
      ],
      access: {
        meta: ["5 seats left"],
        state: OfferAccessState.Available
      }
    }
  },
  // RLO offer (Create instead of Join)
  {
    label: "RLO offer",
    offer: {
      id: 13,
      school_id: SANDBOX_LICENSOR_SCHOOL_ID,
      cover_page_id: 1,
      kind: OfferKind.CreateCohort,
      cohort_id: null,
      resource_license_offering_id: 13,
      scope: OfferScope.Cohort,
      title: "License Cohort",
      description:
        "Ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit.",
      cta_label: null,
      external_url: null,
      position: null,
      price_options: [
        {
          option_label: "$299 per member",
          button_label: "Create Cohort",
          price_description: "$299 per member without subscription"
        }
      ],
      access: {
        meta: [],
        state: OfferAccessState.Available
      }
    }
  },
  // RLO offer with subscription
  {
    label: "RLO offer with subscription",
    offer: {
      id: 14,
      school_id: SANDBOX_LICENSOR_SCHOOL_ID,
      cover_page_id: 1,
      kind: OfferKind.CreateCohort,
      cohort_id: null,
      resource_license_offering_id: 14,
      scope: OfferScope.Cohort,
      title: "License + Subscription",
      description:
        "Sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur.",
      cta_label: null,
      external_url: null,
      position: null,
      price_options: [
        {
          option_label: "$299 per member",
          button_label: "Create Cohort",
          price_description: "$299 per member"
        },
        {
          option_label: "Subscribe",
          button_label: "Subscribe",
          price_description:
            "<strong>$19</strong>/mo., $299 per member without subscription"
        }
      ],
      access: {
        meta: [],
        state: OfferAccessState.Available
      }
    }
  },
  // Limited seats with registration deadline
  {
    label: "Limited seats with registration deadline",
    offer: {
      id: 15,
      school_id: SANDBOX_LICENSOR_SCHOOL_ID,
      cover_page_id: 1,
      kind: OfferKind.JoinCohort,
      cohort_id: 15,
      resource_license_offering_id: null,
      scope: OfferScope.Member,
      title: "Limited Time Cohort",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation.",
      cta_label: null,
      external_url: null,
      position: null,
      price_options: [
        {
          option_label: "$99",
          button_label: "Join for $99",
          price_description: ""
        }
      ],
      access: {
        meta: ["12 seats left", "Registration ends in 2 days"],
        state: OfferAccessState.Available
      }
    }
  }
]
